<app-navbar></app-navbar>
<div class="wrapper">
    <app-info></app-info>
    <app-jumbotron></app-jumbotron>
    <app-activities></app-activities>
    <app-contact></app-contact>
    <app-map></app-map>
    <app-footer></app-footer>
</div>
